<template>
	<div>
		<Breadcrumbs main="Support Management" title="Add Support" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="row mb-3">
								<div class="col-12">
									<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end">
										<i class="bx bx-chevrons-left"></i> Back
									</a>
								</div>
							</div>

							<form @submit.prevent="submitSupport">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3 position-relative">
												<label class="control-label">IMEI / Device<span class="text-danger">*</span></label>
												<input
													class="form-control"
													type="text"
													placeholder="Search IMEI or Vehicle No or Mobile"
													v-model="imei_search"
													@input="searchDevice"
													@focus="showSuggestions = true"
													@blur="hideSuggestions"
													autocomplete="off"
												/>
												<ul
													v-if="showSuggestions && deviceSuggestions.length"
													class="list-group position-absolute w-100"
													style="z-index: 10; max-height: 200px; overflow-y: auto;"
												>
													<li
														v-for="dev in deviceSuggestions"
														:key="dev.imei"
														class="list-group-item list-group-item-action"
														@mousedown.prevent="selectDevice(dev)"
													>
														<strong>{{ dev.imei }}</strong> - {{ dev.vehicle_number || '-' }} - {{ dev.mobile || '-' }}
													</li>
												</ul>
												<div v-if="errors.imei" class="text-danger">{{ errors.imei }}</div>
											</div>
										</div>

										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Support Type<span class="text-danger">*</span></label>
												<select class="form-select" v-model="support_type">
													<option value="">Select</option>
													<option value="1">No Data</option>
													<option value="2">Tracking Issue</option>
													<option value="3">Software Issue</option>
													<option value="4">Alert Fail</option>
													<option value="5">CDCA Alert</option>
													<option value="6">3rd Party App Point</option>
													<option value="7">Other</option>
												</select>
												<div v-if="errors.support_type" class="text-danger">{{ errors.support_type }}</div>
											</div>
										</div>

										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Requested By<span class="text-danger">*</span></label>
												<select class="form-select" v-model="requested_by" @change="onRequestedByChange">
													<option value="">Select</option>
													<option value="1">Customer</option>
													<option value="2">Dealer</option>
												</select>
												<div v-if="errors.requested_by" class="text-danger">{{ errors.requested_by }}</div>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-md-4" v-if="requested_by == '1'">
											<div class="mb-3 position-relative">
												<label class="control-label">Customer<span class="text-danger">*</span></label>
												<input
													class="form-control"
													type="text"
													placeholder="Search customer..."
													v-model="customerSearch"
													@input="showCustomerSuggestions = true"
													@focus="showCustomerSuggestions = true"
													@blur="hideCustomerSuggestions"
													autocomplete="off"
												/>
												<ul
													v-if="showCustomerSuggestions && filteredCustomers.length"
													class="list-group position-absolute w-100"
													style="z-index: 10; max-height: 200px; overflow-y: auto;"
												>
													<li
														v-for="cust in filteredCustomers"
														:key="cust.user_id"
														class="list-group-item list-group-item-action"
														@mousedown.prevent="selectCustomer(cust)"
													>
														{{ cust.company_name }} - {{ cust.mobile }}
													</li>
												</ul>
												<div v-if="selectedCustomer" class="mt-2">
													<small class="text-success">
														Selected: <strong>{{ selectedCustomer.company_name }}</strong>
													</small>
												</div>
												<div v-if="errors.customer_id" class="text-danger">{{ errors.customer_id }}</div>
											</div>
										</div>

										<div class="col-md-4" v-if="requested_by == '2'">
											<div class="mb-3 position-relative">
												<label class="control-label">Dealer<span class="text-danger">*</span></label>
												<input
													class="form-control"
													type="text"
													placeholder="Search dealer..."
													v-model="dealerSearch"
													@input="showDealerSuggestions = true"
													@focus="showDealerSuggestions = true"
													@blur="hideDealerSuggestions"
													autocomplete="off"
												/>
												<ul
													v-if="showDealerSuggestions && filteredDealers.length"
													class="list-group position-absolute w-100"
													style="z-index: 10; max-height: 200px; overflow-y: auto;"
												>
													<li
														v-for="dealer in filteredDealers"
														:key="dealer.user_id"
														class="list-group-item list-group-item-action"
														@mousedown.prevent="selectDealer(dealer)"
													>
														{{ dealer.first_name }}
													</li>
												</ul>
												<div v-if="selectedDealer" class="mt-2">
													<small class="text-success">
														Selected: <strong>{{ selectedDealer.first_name }}</strong>
													</small>
												</div>
												<div v-if="errors.dealer_id" class="text-danger">{{ errors.dealer_id }}</div>
											</div>
										</div>

										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Customer Name</label>
												<input class="form-control" type="text" v-model="customer_name" placeholder="Optional display name" />
											</div>
										</div>

										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Mobile</label>
												<input class="form-control" type="text" v-model="mobile" maxlength="10" placeholder="Optional" />
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-12">
											<div class="mb-3">
												<label class="control-label">Details</label>
												<textarea class="form-control" rows="3" v-model="details" placeholder="Support details"></textarea>
												<div v-if="errors.details" class="text-danger">{{ errors.details }}</div>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-12">
											<div class="mb-3">
												<label class="control-label">Remarks</label>
												<textarea class="form-control" rows="2" v-model="remarks" placeholder="Optional remarks"></textarea>
											</div>
										</div>
									</div>

									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit" :disabled="submitting">
												<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status"></span>
												{{ submitting ? 'Saving...' : 'Save' }}
											</button>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AddSupport',
	data() {
		return {
			token: '',
			submitting: false,
			errors: {},
			imei: '',
			imei_search: '',
			support_type: '',
			requested_by: '',
			customer_name: '',
			mobile: '',
			details: '',
			remarks: '',
			deviceSuggestions: [],
			showSuggestions: false,
			searchTimeout: null,
			dealers: [],
			companies: [],
			selectedDealer: null,
			selectedCustomer: null,
			dealerSearch: '',
			customerSearch: '',
			showDealerSuggestions: false,
			showCustomerSuggestions: false,
			selectedDevice: null,
		};
	},
	computed: {
		filteredDealers() {
			if (!this.dealerSearch.trim()) return this.dealers;
			const q = this.dealerSearch.toLowerCase();
			return this.dealers.filter((d) => (d.first_name || '').toLowerCase().includes(q));
		},
		filteredCustomers() {
			if (!this.customerSearch.trim()) return this.companies;
			const q = this.customerSearch.toLowerCase();
			return this.companies.filter((c) =>
				(c.company_name || '').toLowerCase().includes(q)
				|| String(c.mobile || '').includes(q)
			);
		},
	},
	mounted() {
		this.fetchDealers();
		this.fetchCompanies();
	},
	methods: {
		getToken() {
			if (localStorage.getItem('airotrack_staff')) {
				const airotrack_staff = JSON.parse(localStorage.getItem('airotrack_staff'));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
				} else {
					this.$swal('', 'Failed to fetch token, please login again', 'error');
					this.$router.push({ name: 'login' });
				}
			} else {
				this.$swal('', 'Session expired, please login again', 'error');
				this.$router.push({ name: 'login' });
			}
		},
		onRequestedByChange() {
			// Keep device-linked party; only clear the other request type fields.
			if (this.requested_by == '1') {
				this.selectedDealer = null;
				this.dealerSearch = '';
				if (this.selectedDevice) {
					this.applyDeviceDefaultsFromLookup(this.selectedDevice);
				}
			} else if (this.requested_by == '2') {
				this.selectedCustomer = null;
				this.customerSearch = '';
				if (this.selectedDevice) {
					this.applyDeviceDefaultsFromLookup(this.selectedDevice);
				}
			} else {
				this.selectedDealer = null;
				this.selectedCustomer = null;
				this.dealerSearch = '';
				this.customerSearch = '';
			}
		},
		hideSuggestions() {
			setTimeout(() => { this.showSuggestions = false; }, 200);
		},
		hideDealerSuggestions() {
			setTimeout(() => { this.showDealerSuggestions = false; }, 200);
		},
		hideCustomerSuggestions() {
			setTimeout(() => { this.showCustomerSuggestions = false; }, 200);
		},
		searchDevice() {
			this.getToken();
			if (!this.imei_search.trim()) {
				this.deviceSuggestions = [];
				this.showSuggestions = false;
				return;
			}
			if (this.searchTimeout) clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {
				this.$axios
					.get('staffs/deviceLists', {
						params: { keyword: this.imei_search.trim() },
						headers: { Authorization: `Bearer ${this.token}` },
					})
					.then((response) => {
						if (response.data.status === 'true' || response.data.status === true) {
							this.deviceSuggestions = response.data.data || [];
							this.showSuggestions = true;
						} else {
							this.deviceSuggestions = [];
							this.showSuggestions = false;
						}
					})
					.catch(() => {
						this.deviceSuggestions = [];
						this.showSuggestions = false;
					});
			}, 300);
		},
		selectDevice(device) {
			this.selectedDevice = device;
			this.imei = device.imei || '';
			this.imei_search = device.imei || '';
			this.mobile = device.mobile || '';
			this.customer_name = device.customer_name || this.customer_name || '';
			this.showSuggestions = false;
			this.deviceSuggestions = [];

			this.selectedDealer = null;
			this.selectedCustomer = null;
			this.dealerSearch = '';
			this.customerSearch = '';

			this.applyDeviceDefaultsFromLookup(device);
		},
		applyDeviceDefaultsFromLookup(device) {
			Promise.all([this.fetchDealers(), this.fetchCompanies()]).then(() => {
				let matchedDealer = null;
				let matchedCustomer = null;

				if (device?.dealer_id) {
					matchedDealer = this.dealers.find((d) => d.id == device.dealer_id) || null;
					if (matchedDealer) {
						this.selectedDealer = matchedDealer;
						this.dealerSearch = matchedDealer.first_name || '';
					}
				}

				if (device?.company_id) {
					matchedCustomer = this.companies.find((c) => c.id == device.company_id) || null;
					if (matchedCustomer) {
						this.selectedCustomer = matchedCustomer;
						this.customerSearch = matchedCustomer.company_name || '';
						this.customer_name = this.customer_name || matchedCustomer.company_name || device.customer_name || '';
						this.mobile = this.mobile || matchedCustomer.mobile || device.mobile || '';
					}
				}

				if (!this.mobile && device?.mobile) {
					this.mobile = device.mobile;
				}
				if (!this.customer_name && device?.customer_name) {
					this.customer_name = device.customer_name;
				}

				// Auto set requested_by from device parties when not chosen yet,
				// or keep current selection and ensure corresponding party stays filled.
				if (!this.requested_by) {
					if (matchedDealer && !matchedCustomer) {
						this.requested_by = '2';
					} else if (matchedCustomer && !matchedDealer) {
						this.requested_by = '1';
					} else if (matchedDealer) {
						this.requested_by = '2';
					} else if (matchedCustomer) {
						this.requested_by = '1';
					}
				}
			});
		},
		fetchDealers() {
			this.getToken();
			return this.$axios
				.get('/staffs/dealers', { headers: { Authorization: 'Bearer ' + this.token } })
				.then((res) => {
					const data = res.data.data || res.data;
					this.dealers = Array.isArray(data) ? data : (data.data || []);
					return this.dealers;
				})
				.catch(() => {
					this.dealers = [];
					return [];
				});
		},
		fetchCompanies() {
			this.getToken();
			return this.$axios
				.get('/staffs/companies', { headers: { Authorization: 'Bearer ' + this.token } })
				.then((res) => {
					const data = res.data.data || res.data;
					this.companies = Array.isArray(data) ? data : (data.data || []);
					return this.companies;
				})
				.catch(() => {
					this.companies = [];
					return [];
				});
		},
		selectDealer(dealer) {
			this.selectedDealer = dealer;
			this.dealerSearch = dealer.first_name;
			this.showDealerSuggestions = false;
		},
		selectCustomer(cust) {
			this.selectedCustomer = cust;
			this.customerSearch = cust.company_name;
			this.customer_name = cust.company_name || this.customer_name || '';
			this.mobile = cust.mobile || this.mobile || '';
			this.showCustomerSuggestions = false;
		},
		submitSupport() {
			this.errors = {};
			if (!this.imei && this.imei_search) {
				this.imei = this.imei_search.trim();
			}
			if (!this.imei) {
				this.errors.imei = 'IMEI is required';
			}
			if (!this.support_type) {
				this.errors.support_type = 'Support type is required';
			}
			if (!this.requested_by) {
				this.errors.requested_by = 'Requested by is required';
			}
			if (this.requested_by == '1' && !this.selectedCustomer?.user_id) {
				this.errors.customer_id = 'Customer is required';
			}
			if (this.requested_by == '2' && !this.selectedDealer?.user_id) {
				this.errors.dealer_id = 'Dealer is required';
			}
			if (Object.keys(this.errors).length) {
				return;
			}

			this.submitting = true;
			this.getToken();

			const payload = {
				imei: this.imei,
				support_type: this.support_type,
				requested_by: this.requested_by,
				details: this.details || null,
				remarks: this.remarks || null,
				customer_name: this.customer_name || null,
				mobile: this.mobile || null,
			};

			if (this.requested_by == '1') {
				payload.customer_id = this.selectedCustomer.user_id;
			} else {
				payload.dealer_id = this.selectedDealer.user_id;
			}

			this.$axios
				.post('/staffs/addSupport', payload, {
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				})
				.then((res) => {
					this.submitting = false;
					this.$swal('Success', res.data.message || 'Support created successfully', 'success');
					this.$router.push({ name: 'supports' });
				})
				.catch((error) => {
					this.submitting = false;
					if (this.$applyApiFieldErrors) {
						this.$applyApiFieldErrors(this.errors, error);
					}
					this.$swal('Error', this.$getApiErrorMessage?.(error, 'Failed to create support') || 'Failed to create support', 'error');
				});
		},
	},
};
</script>

<style>
@import '@/assets/css/custom.css';
</style>
